import { render, staticRenderFns } from "./CardBarChartExample.vue?vue&type=template&id=5b448532"
import script from "./CardBarChartExample.vue?vue&type=script&lang=js"
export * from "./CardBarChartExample.vue?vue&type=script&lang=js"
import style0 from "./CardBarChartExample.vue?vue&type=style&index=0&id=5b448532&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports